
import React, { useState } from 'react';
import Button from '../base/Button';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isIndustriesDropdownOpen, setIsIndustriesDropdownOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-b border-gray-200/50">
      <nav className="w-full px-6 py-2">
        <div className="flex items-center justify-between max-w-7xl mx-auto h-16">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/c0d1285fec052420b550c183fa81f8a4.png" 
              alt="Ligare AI" 
              className="h-14 w-auto"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#services" className="text-gray-600 hover:text-black transition-colors cursor-pointer text-sm font-medium">
              Services
            </a>
            <div className="relative">
              <button
                onClick={() => setIsIndustriesDropdownOpen(!isIndustriesDropdownOpen)}
                className="text-gray-600 hover:text-black transition-colors cursor-pointer text-sm font-medium flex items-center"
              >
                Industries
                <i className={`ri-arrow-down-s-line ml-1 transition-transform ${isIndustriesDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {isIndustriesDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200/50 py-2 z-50">
                  <a href="#real-estate" className="block px-4 py-2 text-sm text-gray-600 hover:text-black hover:bg-gray-50 transition-colors cursor-pointer">
                    Real estate
                  </a>
                  <a href="#financial-services" className="block px-4 py-2 text-sm text-gray-600 hover:text-black hover:bg-gray-50 transition-colors cursor-pointer">
                    Financial services
                  </a>
                  <a href="#home-services" className="block px-4 py-2 text-sm text-gray-600 hover:text-black hover:bg-gray-50 transition-colors cursor-pointer">
                    Home services
                  </a>
                </div>
              )}
            </div>
            <a href="#add-ons" className="text-gray-600 hover:text-black transition-colors cursor-pointer text-sm font-medium">
              Solutions
            </a>
            <Button variant="primary" size="sm" className="text-sm">
              Get Started
            </Button>
          </div>
          
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="w-6 h-6 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-gray-600`}></i>
            </button>
          </div>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200/50">
            <div className="flex flex-col space-y-4 pt-4">
              <a href="#services" className="text-gray-600 hover:text-black transition-colors cursor-pointer text-sm font-medium">
                Services
              </a>
              <div>
                <button
                  onClick={() => setIsIndustriesDropdownOpen(!isIndustriesDropdownOpen)}
                  className="text-gray-600 hover:text-black transition-colors cursor-pointer text-sm font-medium flex items-center w-full"
                >
                  Industries
                  <i className={`ri-arrow-down-s-line ml-1 transition-transform ${isIndustriesDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isIndustriesDropdownOpen && (
                  <div className="ml-4 mt-2 space-y-2">
                    <a href="#real-estate" className="block text-sm text-gray-600 hover:text-black transition-colors cursor-pointer">
                      Real estate
                    </a>
                    <a href="#financial-services" className="block text-sm text-gray-600 hover:text-black transition-colors cursor-pointer">
                      Financial services
                    </a>
                    <a href="#home-services" className="block text-sm text-gray-600 hover:text-black transition-colors cursor-pointer">
                      Home services
                    </a>
                  </div>
                )}
              </div>
              <a href="#add-ons" className="text-gray-600 hover:text-black transition-colors cursor-pointer text-sm font-medium">
                Solutions
              </a>
              <Button variant="primary" size="sm" className="w-fit text-sm">
                Get Started
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
